// @flow

export default class HttpError extends Error {
  statusCode: number;

  responseText: ?string;

  responseJson: ?string;

  errors: ?APIErrors;

  constructor(method: string, url: string, xhr: XMLHttpRequest) {
    const messageParts = [
      `Request URL: ${url}`,
      `Request method: ${method}`,
      `Status code: ${xhr.status}`,
      `Response headers: \r\n${xhr.getAllResponseHeaders()}`
    ];
    if (xhr.responseText) {
      messageParts.push(`\r\nResponse body: \r\n${xhr.responseText}`);
    }
    super(messageParts.join('\r\n'));

    this.name = 'HTTPError';
    this.statusCode = xhr.status;
    if (xhr.responseText) {
      this.responseText = xhr.responseText;
      if (xhr.getResponseHeader('Content-Type').indexOf('json') > -1) {
        try {
          this.responseJson = JSON.parse(xhr.responseText);
          this.errors = this.responseJson.errors.reduce(
            (acc, { description, name }) => {
              acc[name] = description;
              return acc;
            },
            {}
          );
        } catch (err) {}
      }
    }
  }
}
